import {
  CLOSE_VIEW_PROFILE_MODAL,
  OPEN_VIEW_PROFILE_MODAL,
  SET_CURRENT_USER,
} from './constants';

const INIT_STATE = {
  isOpenViewProfileModal: false,
};

export default (localState = INIT_STATE, action) => {
  switch (action.type) {
    case SET_CURRENT_USER: {
      return {
        ...localState,
        currentUser: action.payload,
      };
    }
    case OPEN_VIEW_PROFILE_MODAL: {
      return {
        ...localState,
        isOpenViewProfileModal: true,
      };
    }
    case CLOSE_VIEW_PROFILE_MODAL: {
      return {
        ...localState,
        isOpenViewProfileModal: false,
      };
    }
    default:
      return { ...localState };
  }
};
